import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LocalizationEnum } from "../../utils/types/blog";
import { createBlog } from "../../services/blogService";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

export default function BlogCreate() {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [content, setContent] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [localization, setLocalization] = useState<LocalizationEnum>(1);
  const [loading, setLoading] = useState(false);
  const [mainImage, setMainImage] = useState<File | null>(null);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
        setMainImage(e.target.files[0]);
    }
  };

  const modules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"], // <- image button
        ["clean"],
    ],
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("excerpt", excerpt);
    formData.append("content", content);
    formData.append("isPublished", isPublished.toString());
    formData.append("localization", localization.toString());
    if (mainImage) formData.append("MainImageFile", mainImage);

    setLoading(true);
  try {
    await createBlog(formData); 
    navigate("/admin/blogs");
  } catch (err) {
    console.error(err);
    alert("Failed to create blog");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Add New Blog</h1>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Title"
          className="border px-3 py-2 rounded"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Excerpt"
          className="border px-3 py-2 rounded"
          value={excerpt}
          onChange={(e) => setExcerpt(e.target.value)}
          required
        />

        <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="border px-3 py-2 rounded"
        />

        <ReactQuill theme="snow" value={content} onChange={setContent} modules={modules} />

        <select
          value={localization}
           onChange={(e) => setLocalization(Number(e.target.value) as LocalizationEnum)}
          className="border px-3 py-2 rounded"
        >
        <option value={1}>MK</option>
        <option value={2}>RS</option>
        <option value={3}>EN</option>
        </select>

        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={isPublished}
            onChange={(e) => setIsPublished(e.target.checked)}
          />
          Published
        </label>
        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded hover:opacity-80"
          disabled={loading}
        >
          {loading ? "Saving..." : "Create Blog"}
        </button>
      </form>
    </div>
  );
}